import { combineReducers } from "@reduxjs/toolkit";
import {
  authSlice,
  bannerSlice,
  companySlice,
  pageSlice,
  userSlice,
  settingSlice,
  subscriptionSlice,
} from "features";
import { locationSlice } from "features/locationService";
const rootReducer = combineReducers({
  auth: authSlice,
  page: pageSlice,
  comapny: companySlice,
  userData: userSlice,
  bannerData: bannerSlice,
  setting: settingSlice,
  subscriptionSlice: subscriptionSlice,
  location: locationSlice,
  // Add additional reducers here
});

export default rootReducer;
